<div class="modal fade" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">New Library</h5>
        <span class="pull-right" (click)="showGroupName()"
          ><i class="fa-solid fa-times"></i
        ></span>
      </div>
      <div class="modal-body">
        <form [formGroup]="newGroupForm" novalidate>
          <div class="row">
            <div class="col-12">
              <div class="control profile-img">
                @if (!preUploadedFile) {
                <div>
                  <img [src]="'../../../assets/images/user-icon.png'" />
                </div>
                } @if (preUploadedFile && preUploadedFile.file_path) {
                <div>
                  <img [src]="preProfileUrl + preUploadedFile.file_path" />
                </div>
                }

                <span class="img-options">
                  <div class="dropdown is-hoverable">
                    <div class="dropdown-trigger">
                      <i class="fa fa-camera"></i>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                      <div class="dropdown-content">
                        <a class="dropdown-item">
                          <label class="file-label">
                            <input
                              class="file-input"
                              name="profile"
                              id="profile"
                              type="file"
                              (change)="onFileChange($event)"
                              #fileInput
                            />
                            <span class="file-label">Add Picture</span>
                          </label>
                        </a>
                        <a class="dropdown-item" (click)="removeSelectedFile()"
                          >Remove Picture</a
                        >
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-3">
              <label class="label"
                >Title
                <span class="required">*</span>
              </label>
            </div>
            <div class="col-9">
              <input
                class="input"
                type="text"
                placeholder=""
                formControlName="chat_group_name"
                (keydown)="keyDownHandler($event)"
                required
              />
              <form-validation
                [control]="newGroupForm.controls.chat_group_name"
              ></form-validation>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-3"><label class="label">Description</label></div>
            <div class="col-9">
              <textarea
                class="textarea"
                placeholder=""
                formControlName="chat_description"
                rows="2"
                (keydown)="keyDownHandler($event)"
              ></textarea>
            </div>
          </div>
          @if (userIdList) {
          <div class="row mt-2 userList">
            <div class="col-12">
              <label class="label class_list"
                >Access Users
                <span class="required">*</span>
                @if (userIdList.length > 0) {
                <p class="display-ib mar-10-0 is-right studentCount">
                  <em> {{ userIdList.length }} users selected </em>
                </p>
                }
              </label>
              <label>(Please select user to this library)</label>
            </div>
            <div class="col-12">
              <div class="panel">
                @if (totalRowCount === 0) { No users to list } @else {
                <div
                  class="userlist field pos-relative scroll-bar"
                  infinite-scroll
                  [infiniteScrollDistance]="modalScrollDistance"
                  [infiniteScrollThrottle]="modalScrollThrottle"
                  [scrollWindow]="false"
                  (scrolled)="fetchNextUserList()"
                >
                  <ul class="list-group">
                    @for (user of listOfUsers; track user) {
                    <li
                      class="panel-block pos-relative"
                      [ngClass]="{
                        'active-bg': userIdList.indexOf(user.user_id) > -1
                      }"
                      (click)="selectUserId(user.user_id)"
                    >
                      <span class="image is-32x32 mar-0-10">
                        @if (!user.user_icon) {
                        <empty-uname
                          [userName]="user.first_name"
                          [detailHeadProfile]="true"
                        ></empty-uname>
                        } @if (user.user_icon) {
                        <img [src]="profileUrl + user.user_icon" />
                        }
                      </span>
                      {{ user.first_name + " " + user.last_name }}
                      @if (userIdList.indexOf(user.user_id) > -1) {
                      <span class="icon is-small icon-align is-pulled-right">
                        <i class="fa fa-check"></i>
                      </span>
                      }
                    </li>
                    }
                  </ul>
                  <!-- <div class="panel">
                      <label class="panel-block pos-relative" [ngClass]="{'active-bg': userIdList.indexOf(user.user_id) > -1}" *ngFor="let user of listOfUsers"
                        (click)="selectUserId(user.user_id)">
                        <span class="image is-32x32 mar-0-10">
                          <empty-uname [userName]="user.first_name" [detailHeadProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                          <img [src]="profileUrl+user.user_icon" *ngIf="user.user_icon">
                        </span>
                        {{user.first_name + ' ' + user.last_name}}
                        <span class="icon is-small icon-align is-pulled-right" *ngIf="userIdList.indexOf(user.user_id) > -1">
                          <i class="fa fa-check"></i>
                        </span>
                      </label>
                      <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                    </div> -->
                </div>
                }
              </div>
            </div>
          </div>
          }
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="showGroupName()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!newGroupForm.valid || userIdList.length == 0"
          (click)="addNewClassRoom(newGroupForm.value)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <div class="col th-p notification-content-wrapper">
<div class="contents is-marginless is-mobile">
  <div class="scroll-bar">
    <div class="column">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <div class="columns new-chat mar-top15">
            <div class="column">
              <div class="card">
                <div class="card-content">
                  <div class="content form-style">

                    <form [formGroup]="newGroupForm" (ngSubmit)="addNewClassRoom(newGroupForm.value)" novalidate>
                      <h3>New Policy</h3>

                      <div class="columns">
                        <div class="column">
                          <div class="field">
                            <div class="control profile-img">
                              <div *ngIf="!preUploadedFile">
                                <img [src]="'../../../assets/images/user-icon.png'">
                              </div>
                              <div *ngIf="preUploadedFile && preUploadedFile.file_path">
                                <img [src]="preProfileUrl+preUploadedFile.file_path">
                              </div>

                              <span class="img-options">
                                <div class="dropdown is-hoverable">
                                  <div class="dropdown-trigger">
                                    <i class="fa fa-camera"></i>
                                  </div>
                                  <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                                    <div class="dropdown-content">
                                      <a class="dropdown-item">
                                        <label class="file-label">
                                          <input class="file-input" name="profile" id="profile" type="file" (change)="onFileChange($event)" #fileInput>
                                          <span class="file-label">Add Picture</span>
                                        </label>
                                      </a>
                                      <a class="dropdown-item" (click)="removeSelectedFile()">Remove Picture</a>
                                    </div>
                                  </div>
                                </div>

                              </span>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="columns">
                        <div class="column is-12">
                          <div class="field">
                            <label class="label">Title
                              <span class="required">*</span>
                            </label>
                            <div class="control">
                              <input class="input" type="text" placeholder="" formControlName="chat_group_name"  (keydown)="keyDownHandler($event)" required>
                              <form-validation [control]="newGroupForm.controls.chat_group_name"></form-validation>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column">
                          <div class="field">
                            <label class="label">Description</label>
                            <div class="control">
                              <textarea class="textarea" placeholder="" formControlName="chat_description" rows="2" (keydown)="keyDownHandler($event)" ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="columns userList" *ngIf="userIdList">
                        <div class="column">
                          <label class="label class_list">Access Users
                            <span class="required">*</span>
                            <p class="display-ib mar-10-0 is-right studentCount" *ngIf="userIdList.length > 0">
                              <em> {{userIdList.length}} users selected </em>
                            </p>
                          </label>
                          <span class="subtitle is-small addStuSubTitle">(Please select user to this policy)</span>
                          <div class="panel-block" style="display: none;">
                            <p class="control has-icons-left">
                              <input class="input is-small" type="text" placeholder="search" [(ngModel)]="searchText" (keyup)='searchInList.next($event)'>
                              <span class="icon is-small is-left">
                                <i class="fa fa-search"></i>
                              </span>
                            </p>
                          </div>
                          <div class="pos-relative scroll-bar" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                            [scrollWindow]="false" (scrolled)="fetchNextUserList()">
                            <div class="panel">
                              <div class="column" *ngIf="totalRowCount === 0">
                                No users to list
                              </div>
                              <div class="column" *ngIf="totalRowCount > 0">
                                <div class="field pos-relative scroll-bar" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                                  [scrollWindow]="false" (scrolled)="fetchNextUserList()">
                                  <div class="panel">
                                    <label class="panel-block pos-relative" [ngClass]="{'active-bg': userIdList.indexOf(user.user_id) > -1}" *ngFor="let user of listOfUsers"
                                      (click)="selectUserId(user.user_id)">
                                      <span class="image is-32x32 mar-0-10">
                                        <empty-uname [userName]="user.first_name" [detailHeadProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                                        <img [src]="profileUrl+user.user_icon" *ngIf="user.user_icon">
                                      </span>
                                      {{user.first_name + ' ' + user.last_name}}
                                      <span class="icon is-small icon-align is-pulled-right" *ngIf="userIdList.indexOf(user.user_id) > -1">
                                        <i class="fa fa-check"></i>
                                      </span>
                                    </label>

                                    <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="columns display-flex is-clearfix">
                        <div class="column is-4" style="display: none;">
                          <button type="button" class="button is-link" [disabled]="!newGroupForm.valid" (click)="openAddUserSection()">Add Student</button>
                          <p class="display-ib mar-10-0" *ngIf="userIdList.length > 0">
                            <em> {{userIdList.length}} users added </em>
                          </p>
                        </div>
                        <div class="column is-12">
                          <div class="has-text-right">

                            <button class="button mar-0-5 is-small"  (click)="showGroupName()">Cancel</button>
                            <button class="button is-link is-small" [disabled]="!newGroupForm.valid">Save</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->

<!-- User list modal -->
<!-- <div class="modal" [ngClass]="{'is-active':toggleModalSection}">
<div class="modal-background"></div>
<div class="modal-card">
  <div class="modal-card-head">
    <p class="modal-card-title">Select Students</p>
  </div>
  <section class="modal-card-body">
    <div class="content">
      <div class="columns">
        <div class="column">
          <div class="field">
            <div class="panel-block">
              <p class="control has-icons-left has-icons-right">
                <input class="input is-small" type="text" placeholder="search" [(ngModel)]="searchText" (keyup.enter)="userSearchAndPagination(0)">
                <input class="input is-small" type="text" placeholder="search" [(ngModel)]="searchText" (keyup)='searchInList.next($event)'>
                <span class="icon is-small is-left">
                  <i class="fa fa-search"></i>
                </span>
                <span class="icon is-small is-right">
                  <i class="fa fa-close"></i>
                </span>
              </p>
            </div>
            <div class="panel panel-overflow" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
              [scrollWindow]="false" (scrolled)="onScrollDown()">

              <div class="panel panel-overflow scroll-bar" appInfiniteScroll (reachedBottom)="onScrollDown()">
                <label class="panel-block pos-relative" [ngClass]="{'active-bg': userIdList.indexOf(user.user_id) > -1}" *ngFor="let user of listOfUsers"
                  (click)="selectUserId(user.user_id)">
                  <span class="image is-32x32 mar-0-10">
                    <empty-uname [userName]="user.first_name" [detailHeadProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                    <img [src]="profileUrl+user.user_icon" *ngIf="user.user_icon">
                  </span>
                  {{user.first_name + ' ' + user.last_name}}
                  <span class="icon is-small icon-align is-pulled-right" *ngIf="userIdList.indexOf(user.user_id) > -1">
                    <i class="fa fa-check"></i>
                  </span>
                </label>
                <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-card-foot">
      <div class="column has-text-right">
        <button type="button" class="button is-right mar-0-10" (click)="clearAddUserSection()">Cancel</button>
        <button type="submit" class="button is-link is-right" (click)="openAddUserSection()">Ok</button>
      </div>
    </div>
  </div>
</div> -->
